var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTermsOfUse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49658 15.0132C7.82022 15.0132 8.08252 14.7507 8.08252 14.4272V12C8.08252 11.6764 7.82022 11.4141 7.49658 11.4141C7.1731 11.4141 6.91065 11.6764 6.91065 12V14.4272C6.91065 14.7507 7.1731 15.0132 7.49658 15.0132Z",
    fill: "#9B9B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.398 6.427H11.5494V3.57269C11.5494 1.60263 9.73281 0 7.49992 0C5.26719 0 3.45059 1.60263 3.45059 3.57269V6.427H0.601875C0.269433 6.427 0 6.68945 0 7.01294V14.5064C0 17.5356 2.53148 20 5.64304 20H9.35695C12.4685 20 15 17.5356 15 14.5064V7.01294C14.9998 6.68945 14.7304 6.427 14.398 6.427ZM4.65434 3.57269C4.65434 2.24884 5.93082 1.17188 7.49992 1.17188C9.06903 1.17188 10.3457 2.24884 10.3457 3.57269V6.427H4.65434V3.57269ZM13.7961 14.5064C13.7961 16.8893 11.8047 18.8281 9.3568 18.8281H5.64304C3.19526 18.8281 1.20375 16.8893 1.20375 14.5064V7.59888H13.7961V14.5064Z",
    fill: "#9B9B9B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsOfUse);
export default __webpack_public_path__ + "static/media/terms-of-use.260cb9b75ed47804aeea1ae39024b63f.svg";
export { ForwardRef as ReactComponent };